import { useContext } from 'react'

import AppConfigContext from './app-config-context'
import type { AppConfig } from './types.d'

const useAppConfig = (): AppConfig.Config => useContext(AppConfigContext) || {}

export default useAppConfig
